import React, { memo } from 'react'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import VideoGroupItem from '../VideoGroupItem'
import SectionHeader from './SectionHeader'
import { FREE_VIDEO_GROUP_KEYS } from '../consts'
import { IVideoDropdownModel, IVideoModelGroup } from '../types'
import * as Styled from './styled'

interface ISectionedModelListProps {
  groups: IVideoModelGroup[]
  selectedKey: string | null
  onSelect: (model: IVideoDropdownModel) => void
  getGroupLabels: (group: IVideoModelGroup) => string[]
  onInnerSlideUpOpenChange?: (open: boolean) => void
}

const SectionedModelList: React.FC<ISectionedModelListProps> = ({
  groups,
  selectedKey,
  onSelect,
  getGroupLabels,
  onInnerSlideUpOpenChange
}) => {
  const freeGroups = groups.filter(g => FREE_VIDEO_GROUP_KEYS.has(g.key))
  const premiumGroups = groups.filter(g => !FREE_VIDEO_GROUP_KEYS.has(g.key))

  const renderGroup = (group: IVideoModelGroup) => (
    <VideoGroupItem
      key={group.key}
      group={group}
      selectedKey={selectedKey}
      onSelect={onSelect}
      labels={getGroupLabels(group)}
      onMobileExpandChange={onInnerSlideUpOpenChange}
    />
  )

  const hasBothSections = freeGroups.length > 0 && premiumGroups.length > 0

  return (
    <Styled.DropdownListWrapper>
      {freeGroups.length > 0 && (
        <Styled.SectionBlock>
          <SectionHeader
            label={translate(T.VIDEO_MODELS_FREE_SECTION, { isUpper: true })}
          />
          {freeGroups.map(renderGroup)}
        </Styled.SectionBlock>
      )}
      {hasBothSections && <Styled.SectionDivider />}
      {premiumGroups.length > 0 && (
        <Styled.SectionBlock>
          <SectionHeader
            label={translate(T.VIDEO_MODELS_PREMIUM_SECTION, {
              isUpper: true
            })}
          />
          {premiumGroups.map(renderGroup)}
        </Styled.SectionBlock>
      )}
    </Styled.DropdownListWrapper>
  )
}

export default memo(SectionedModelList)
